import { ApplicationType } from '@/features/application-filling/types';

export const APPLICATION_TYPE_LABELS: {
  [key in ApplicationType]: string;
} = {
  ['IRA']: 'IRA',
  ['SOLO_401K']: 'Solo 401(k) Deposit',
  ['LLC']: 'LLC Deposit',
  ['TRUST_DEPOSIT']: 'Trust Deposit',
};
